export const PROFILE_KEY = ['profile'];
export const AUTH_KEY = ['auth'];
export const DASHBOARD_KEY = ['dashboard'];
export const MATCH_KEY = ['match']; 
export const AI_CHAT_KEY = ['ai-chat'];
export const AGENT_REVIEW_KEY = ['agent-review'];
export const CHAT_KEY = ['chat'];
export const TOURS_KEY = ['tours'];